import { SxProps, TextField } from '@mui/material';
import { useController } from 'react-hook-form';
import { formatDateTimeEST } from 'shared/utility';

type FormDateFieldProps = {
  name: string;
  label: string;
  disabled?: boolean;
  sx?: SxProps;
};

export function FormDateField({ name, label, disabled, sx }: FormDateFieldProps) {
  const {
    field: { ref, value, ...inputProps },
  } = useController({
    name,
  });
  // after deleting legacy date from all envs leave only formatDateTimeEST(new Date(value))
  const formattedDate = value?.includes('Z') ? formatDateTimeEST(new Date(value)) : value;

  return (
    <TextField
      {...inputProps}
      value={formattedDate}
      id={name}
      inputRef={ref}
      variant='outlined'
      label={label}
      disabled={disabled}
      sx={sx}
    />
  );
}
